// Endpoint: GET ;
import axios from 'axios';
import { BASE_URL } from '../../constants/apiPaths';
import { getAccessToken } from '../../firebase';
import { toast } from 'sonner';
const getConfig = (token) => {
    return {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
};

export const getImpactPointsUnused = async () => {
    try {
        const url = `${BASE_URL}/citizen/activityImpactPoints`;
        const accessToken = await getAccessToken();
        const response = await axios.get(url, getConfig(accessToken));
        console.log(response, 'fetching data of nft id');
        if (response.status === 200 || response.status === 201) {
            return response.data;
        } else {
            return response; // or throw an error, depending on your error handling strategy
        }
    } catch (error) {
        return error;
    }
};
